import { render, staticRenderFns } from "./LoaderRingWave.vue?vue&type=template&id=546b6a92&scoped=true&"
import script from "./LoaderRingWave.vue?vue&type=script&lang=js&"
export * from "./LoaderRingWave.vue?vue&type=script&lang=js&"
import style0 from "./LoaderRingWave.vue?vue&type=style&index=0&id=546b6a92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546b6a92",
  null
  
)

export default component.exports